import React, { useEffect, useState } from "react";
import { useUpdateLoanMutation } from "../../../../../../services/RTKQuery/loans";

export const UpdateTest = ({ loanUuid, setStatusInParent }) => {
  const statusUnknown = "❓Unknown Status";
  const statusPass = "✅ Pass";
  const statusFail = "❌ Fail";

  const [statusUpdate, setStatusUpdate] = useState(statusUnknown);
  const [detailsText, setDetailsText] = useState("statusUnknown");

  const [updateLoanMutation] = useUpdateLoanMutation();
  useEffect(() => {
    updateLoanMutation({
      uuid: loanUuid,
      purchase_money: false
    })
      .unwrap()
      .then(fulfilled => {
        if (fulfilled?.data?.purchase_money === false) {
          setStatusUpdate(statusPass);
          setDetailsText(
            `: purchase_money updated to: ${fulfilled.data.purchase_money}`
          );
          setStatusInParent("Pass");
        } else {
          setStatusUpdate(statusFail);
          setStatusInParent("Fail");
        }
      })
      .catch(error => {
        console.error("Fail: useUpdateLoanMutation", error);
        setStatusUpdate(statusFail);
      });
  }, [loanUuid, setStatusInParent, updateLoanMutation]);

  return (
    <>
      <b>{statusUpdate}</b>
      <small>{detailsText}</small>
    </>
  );
};
